import { LoadingButton } from '@mui/lab';
import { styled } from '@mui/material';

export const SubmitButton = styled(LoadingButton)({
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
});
